import UpdateCandidateStatus from './UpdateCandidateStatus.container';

export default UpdateCandidateStatus;
